import { render } from "./composition.vue?vue&type=template&id=3f3b198b&scoped=true"
import script from "./composition.vue?vue&type=script&lang=js"
export * from "./composition.vue?vue&type=script&lang=js"

import "./composition.vue?vue&type=style&index=0&id=3f3b198b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3b198b"]])

export default __exports__